import { useContext, useState } from "react";
import TabFive from "./TabFive";
import TablePrimary, { TablePrimaryProps } from "../../Table/TablePrimary";
import ReactVisibilitySensor from "react-visibility-sensor";
import { LangContext } from "../../../App";

type Card = {
    icon : string;
    text : string;
}

type TabFiveProps = {
    cards : Card[];
}

type TabsViewFiveProps = {
    headers : string[];
    tableHeaders : string[];
    tabs : {
        title : string;
        icon : string;
        description : string;
        page : string,
    }[][];
}

const TabsViewFive = ({ headers, tabs, tableHeaders } : TabsViewFiveProps) => {
    const { lang } = useContext(LangContext);
    const [activeIndex, setActiveIndex] = useState<number>(0);

  return (
    <div className="tabs-view-five">
        <div className="tabs-headers">
            {headers.map((item, index) => (
                <button 
                    key={index}
                    type="button"
                    className={`tab-button ${index === activeIndex ? "active" : ""}`}
                    onClick={() => setActiveIndex(index)}
                    title={`Show ${headers[index]} tab`}
                    aria-label={`Show ${headers[index]} tab`}
                    aria-pressed={index !== activeIndex}
                >{item}</button>
            ))}
        </div>
        <div className="tabs-container">

            {tabs.map((item, index) => (
                <div className={`tab-wrapper ${index === activeIndex ? "active" : ""}`} key={index}>
                        <TablePrimary
                            headers={tableHeaders}
                            textDirection={["s", "s", "s", "e"]}
                        >
                            {item.map((item, index) => (
                                <ReactVisibilitySensor
                                partialVisibility
                                >
                                {({isVisible} : any) => (
                                <tr key={index}>
                                    <td className={`an-fade-in ${isVisible ? "an-active" : ""}`}>{item.title}</td>
                                    <td>
                                    <img 
                                        src={require(`../../../assets/icons/materials-icons/table/${item.icon}`)} 
                                        alt="Dummy icon" 
                                        className={`icon an-pop-up ${isVisible ? "an-active" : ""}`}
                                    />
                                    </td>
                                    <td style={{ minWidth : 500 }} className={`an-fade-in ${isVisible ? "an-active" : ""}`}>{item.description}</td>
                                    <td className={`${lang ? "" : "td-e"} an-fade-in ${isVisible ? "an-active" : ""}`}>{item.page}</td>
                                </tr>
                                )}
                                </ReactVisibilitySensor>
                            ))}
                        </TablePrimary>
                </div>
            ))}
        </div>
    </div>
  )
}

export default TabsViewFive